module.exports = __webpack_public_path__ + "img/state2.95b890df.webp";